import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
export function useStudentProfile() {
    return useQuery({
        queryKey: ['student-profile'],
        queryFn: () => apiClient('/students/me'),
        staleTime: 1000 * 60 * 5,
    });
}
export function useUpdateMyProfile() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (dto) => apiClient('/students/me', { method: 'PATCH', body: JSON.stringify(dto) }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['student-profile'] }),
    });
}
/** Upload a new profile photo (multipart). Refreshes the profile on success. */
export function useUpdateMyAvatar() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (file) => {
            const fd = new FormData();
            fd.append('file', file);
            return apiClient('/students/me/avatar', { method: 'POST', body: fd });
        },
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['student-profile'] }),
    });
}
//# sourceMappingURL=useStudentProfile.js.map